// Apple Pencil / iPad Safari helpers.
//
// On iPad, WebKit reports an Apple Pencil in TWO ways at once:
//   1. Pointer Events with pointerType === "pen"
//   2. Touch Events whose touches have touchType === "stylus"
// and, unlike desktop browsers, a Pencil drag scrolls the page by default.
// preventDefault() on pointerdown does NOT stop that scroll — only a
// non-passive touchstart/touchmove preventDefault (or CSS touch-action) does.

// iPadOS 13+ reports itself as "MacIntel" in desktop mode, so also check touch points.
export const IS_APPLE_TOUCH = typeof navigator !== "undefined" && (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
);

// True when the touch event comes from an Apple Pencil (not a finger).
export function isStylusTouch(e) {
    const list = e?.changedTouches?.length ? e.changedTouches : e?.touches;
    if (!list) return false;
    for (let i = 0; i < list.length; i++) {
        if (list[i].touchType === "stylus") return true;
    }
    return false;
}

// Stops the Apple Pencil from scrolling/panning `el` while fingers still can.
// `shouldBlock(e)` (optional) can veto per event. Returns a cleanup function.
export function blockStylusScroll(el, shouldBlock = () => true) {
    if (!el) return () => {};
    const handler = (e) => {
        if (isStylusTouch(e) && shouldBlock(e) && e.cancelable) e.preventDefault();
    };
    el.addEventListener("touchstart", handler, { passive: false });
    el.addEventListener("touchmove", handler, { passive: false });
    return () => {
        el.removeEventListener("touchstart", handler);
        el.removeEventListener("touchmove", handler);
    };
}
